import React, { useEffect, useState } from "react";
import Loading from "../../components/Loading";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { ApiHandler } from "../../helper/ApiHandler";
import Container from "../../components/Container";
import {
  clearUser,
  setUserData,
  setUserToken,
} from "../../redux/slices/userSlice";
import Breadcrumb from "../../components/Breadcrumb";
import { InputCss } from "../../helper/CommonFunction";

const ProfileForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userToken, userData } = useSelector((state) => state.user);

  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState({
    login_userName: "",
    old_login_password: "",
    new_password: "",
    confirm_new_password: "",
  });

  const [errors, setErrors] = useState({});

  const {
    old_login_password,
    new_password,
    confirm_new_password,
    login_userName,
  } = user;

  useEffect(() => {
    setLoading(true);
    if (userData) {
      setUser({
        ...user,
        login_userName: userData?.username || "",
      });
      setLoading(false);
    }
  }, [userData]);

  const onInputChange = (e) => {
    const updatedErrors = { ...errors };
    if (updatedErrors[e.target.name]) {
      updatedErrors[e.target.name] = "";
      setErrors(updatedErrors);
    }
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const validationForm = () => {
    let formErrors = {};

    if (new_password.length > 0) {
      if (!old_login_password) {
        formErrors.old_login_password = "Please Enter your old password";
      } else if (new_password === old_login_password) {
        formErrors.old_login_password = "Password and Old Password are match";
      }
    }

    if (new_password.length > 0) {
      if (new_password.includes(" ")) {
        formErrors.new_password = "Password should not contain spaces";
      } else if (new_password.length < 8 || new_password.length > 12) {
        formErrors.new_password =
          "Password must be between 8 and 12 characters";
      } else if (!/(?=.*[0-9])/.test(new_password)) {
        formErrors.new_password = "Password must contain at least one number";
      } else if (
        !/(?=.*[`!@#$%^&*()_+\-={}\[\]:;"'<>,.?/~]){3,}/.test(new_password)
      ) {
        formErrors.new_password =
          "Password must contain at least three special characters";
      } else if (!/[qwertyuiopasdfghjklzxcvbnm]/.test(new_password)) {
        formErrors.new_password =
          "Password must have at least one lowercase character";
      } else if (!/[QWERTYUIOPASDFGHJKLZXCVBNM]/.test(new_password)) {
        formErrors.new_password =
          "Password must have at least one uppercase character";
      }
    }

    if (new_password.length > 0) {
      if (!confirm_new_password) {
        formErrors.confirm_new_password = "Please confirm your password";
      } else if (new_password !== confirm_new_password) {
        formErrors.confirm_new_password =
          "Password and confirm password do not match";
      }
    }

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validationForm()) {
      return;
    }

    const body = {
      old_password: new_password ? old_login_password : "",
      password: new_password,
      confirm_password: new_password ? confirm_new_password : "",
    };

    try {
      setLoading(true);
      const result = await ApiHandler(
        "/change_password.php",
        "PUT",
        body,
        userToken,
        dispatch,
        navigate
      );
      if (result?.data.status === "1") {
        setLoading(false);
        toast.success(result.data.msg);
        dispatch(setUserToken(null));
        dispatch(setUserData(null));
        dispatch(clearUser());
        navigate(`/admin/login`);
      } else {
        setLoading(false);
        toast.error(result.data.msg);
        setUser({
          ...user,
          old_login_password: "",
          new_password: "",
          confirm_new_password: "",
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  if (loading) return <Loading />;
  return (
    <>
      <Breadcrumb pageName="AdminProfile" />
      <Container>
        <div className="border border-orange-100 rounded-xl shadow-[0_2px_16px_rgba(0,0,0,0.04)] w-full bg-white">
          <div className="p-4">
            <form action="" onSubmit={handleSubmit}>
              {/* Login Information */}
              <h2 className="text-xl font-semibold mb-4 text-gray-900">
                Login Information
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                <div>
                  <label className="block font-semibold text-gray-700">
                    Login User Name<span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    className={`w-full px-3 py-2.5 border border-orange-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-300 text-gray-500 text-sm cursor-not-allowed bg-orange-50/50`}
                    value={login_userName}
                    readOnly
                  />
                </div>
                <div>
                  <label className="block font-semibold text-gray-700">
                    Old Login Password<span className="text-red-500">*</span>
                  </label>
                  <input
                    className={`${InputCss}`}
                    type="password"
                    name="old_login_password"
                    value={old_login_password}
                    onChange={(e) => onInputChange(e)}
                    required
                  />
                  {errors.old_login_password && (
                    <div className="text-red-500 text-sm font-semibold">
                      {errors.old_login_password}
                    </div>
                  )}
                </div>
                <div>
                  <label className="block font-semibold text-gray-700">
                    New Login Password<span className="text-red-500">*</span>
                  </label>
                  <input
                    className={`${InputCss}`}
                    type="password"
                    name="new_password"
                    value={new_password}
                    onChange={(e) => onInputChange(e)}
                    required
                  />
                  {errors.new_password && (
                    <div className="text-red-500 text-sm font-semibold">
                      {errors.new_password}
                    </div>
                  )}
                </div>
                <div>
                  <label className="block font-semibold text-gray-700">
                    Confirm New Login Password
                  </label>
                  <input
                    className={`${InputCss}`}
                    type="password"
                    name="confirm_new_password"
                    value={confirm_new_password}
                    onChange={(e) => onInputChange(e)}
                    required
                  />
                  {errors.confirm_new_password && (
                    <div className="text-red-500 text-sm font-semibold">
                      {errors.confirm_new_password}
                    </div>
                  )}
                </div>
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                className="bg-orange-500 text-white px-5 py-2.5 rounded-lg font-medium shadow-sm shadow-orange-200 hover:bg-orange-600 transition-colors duration-200"
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      </Container>
    </>
  );
};

export default ProfileForm;